import { HTMLAttributeAnchorTarget } from "react";
import { ReactLink, StrapiLink } from "../models/common";

/**
 * Return link path with locale
 * @param {string} path
 * @param {boolean} isPrivate
 * @returns {string}
 */
export const localizeUrl: (path: string) => string = (path) => {
  if (path.startsWith('/')) return path;
  return `/${path}`;
};

/**
 * Get adequate target for link
 */
const getLinkTarget = (
  isLinkExternal: boolean,
  target: HTMLAttributeAnchorTarget | undefined
): HTMLAttributeAnchorTarget | undefined => {
  if (target) return target;
  if (isLinkExternal) return '_blank';
  return undefined;
};

/**
 * Get adequate attributes (target & rel) for a link
 */
export const getLinkAttributes = (
  isLinkExternal: boolean,
  forcedTarget: HTMLAttributeAnchorTarget | undefined
): { target?: HTMLAttributeAnchorTarget; rel?: string } => {
  const target = getLinkTarget(isLinkExternal, forcedTarget);
  return {
    target,
    rel: target === '_blank' ? 'noopener noreferrer' : undefined
  };
};

/**
 * Transform an array of StrapiLinks into ReactLinks
 * @param {StrapiLink[]} strapiLinks
 * @returns {ReactLink[]}
 */
export const transformLinks = (strapiLinks: StrapiLink[]): ReactLink[] =>
  strapiLinks.map((strapiLink) => {
    return transformLink(strapiLink);
  });

/**
 * Transform StrapiLink into ReactLink
 * @param {StrapiLink} strapiLink
 * @returns {ReactLink}
 */
export const transformLink = (strapiLink: StrapiLink): ReactLink => {
  const isHref = strapiLink.Lien.includes('http');
  return {
    label: strapiLink.Label,
    to: isHref ? undefined : localizeUrl(strapiLink.Lien),
    href: isHref ? strapiLink.Lien : undefined
  };
};

/**
 * Get image src from strapi image url
 * @param {string} url
 * @returns {string}
 */
export const getStrapiMediaSrc = (url: string): string => {
  return process.env.REACT_APP_S3_DISABLED === 'true'
    ? `${process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:1337'}${url}`
    : url;
};
